import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  Collapse,
  Spin,
  Space,
  Row,
  Col,
  Typography,
  Divider,
  DatePicker,
  Select,
  Upload,
  Table,
  notification
} from 'antd';
import moment from 'moment';
import {
  UploadOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  InboxOutlined,
  ConsoleSqlOutlined
} from '@ant-design/icons';
import '../style/style.css';
import FormItem from 'antd/lib/form/FormItem';
import setting from '../../config/setting';
import _ from 'underscore';

const { Text } = Typography;

const { Panel } = Collapse;

const { Option } = Select;

const { TextArea } = Input;

const { Dragger } = Upload;

const vaccines = [
  'Pfizer',
  'Moderna',
  'Janssen',
  'Comirnaty',
  'Tozinameran',
  'Covishield',
  'Vaxzevria',
  'AstraZenca',
  'Takeda',
  'Spikevax',
  'Sinopharm-BIBP',
  'Sinovac-CoronaVac',
  'Covaxin',
  'Covovax',
  'Nuvaxovid'
];
const CovidVaccination = () => {
 
  const [companyName, setCompanyName] = useState('');
  const [CovidVaccinationData, setCovidVaccinationData] = useState([]);
  const [CovidUnvaccinationData, setCovidUnaccinationData] = useState([]);
  const [CovidExemptionData, setCovidExemptionData] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [lastUpdate, setLastUpdate] = useState('');
  const [vaccineStatus, setVaccineStatus] = useState(''); // to see if employee is vaccinated, unvaccinated or has an exemption
  const [loaderVaccinated, setLoaderVaccinated] = useState(false);
  const [loaderExemption, setLoaderExemption] = useState(false);
  const [loaderUnvaccinated, setLoaderUnvaccinated] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [change, setChange] = useState(false);
  const [CovidVulnerableData, setCovidVulnerableData] = useState([]);

  const [errors, setErrors] = useState({
    test_date: '',
    photo_pdf: '',
    test_type: '',
    testing_result: ''
  });

  useEffect(() => {
    if (localStorage.getItem('employeeInfo')) {
      getCovidVaccinationData();
    }
  }, []);

  useEffect(() => {
    getLatestUpdate();
  }, [responseData, vaccineStatus]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setImageUrls([]);
  };

  function download(e, attachment) {
    axios
      .post(setting.serverUrl + '/api/downloadVaccineCertificate_emp', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          attachment_detail: attachment
        }
      })
      .then((response) => {
        if (response && response.status === 200) {
          setChange(!change);
          if (Array.isArray(response.data)) {
            setIsModalVisible(true);
            setImageUrls(response.data);
          } else {
            window.open(response.data);
          }
          // if (Array.isArray(response.data)) {
          //   window.open(response.data[0].url);
          // }
        }
      });
  }

  function getCovidVaccinationData() {
    let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));
    setCompanyName(employeeData.company[1]);
    axios
      .post(setting.serverUrl + '/api/getEmployeeCovidVaccination', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          customerId: employeeData ? employeeData.company[0] : '',
          employeeId: employeeData ? employeeData.id : ''
        }
      })
      .then((response) => {
        if (response && response.status === 200) {

          if (response.data && response.data.error) {
            notification['error']({
              message: 'Error',
              description: response.data.error
            })
          }

          if (Array.isArray(response.data) && response.data.length > 0) {

            let vaccinatedData = [];
            let unvaccinatedData = [];
            let exemptionData = [];
            let vulnerableData = [];
            let vaccDataSorted = _.sortBy(response.data, function (o) {
              return o.create_date;
            }).reverse();
            vaccDataSorted.map((vccData) => {
              if (vccData.vaccinated || vccData.test_type) {
                vaccinatedData.push(vccData);
              }
              if (vccData.unvaccinated) {
                unvaccinatedData.push(vccData);
              }
              if (vccData.exemption) {
                exemptionData.push(vccData);
              }
              if (vccData.exemption_type === 'vulnerable') {
                vulnerableData.push(vccData);
              }
            });

            setCovidVaccinationData(vaccinatedData);
            setCovidUnaccinationData(unvaccinatedData);
            setCovidExemptionData(exemptionData);
            setResponseData(response.data);

            setCovidVulnerableData(vulnerableData)
          }

        } else {
          notification['error']({
            message: 'Error',
            description: 'There is some technical issue. Please try again later.'
          })
        }

      });
  }

  function getLatestUpdate() {
    if (responseData.length > 0) {
      let lastUpdatedData = responseData[responseData.length - 1];

      setLastUpdate(lastUpdatedData.create_date);

      if (lastUpdatedData.vaccinated === true) {
        setVaccineStatus('vaccinated');
      } else if (lastUpdatedData.unvaccinated === true) {
        setVaccineStatus('unvaccinated');
      } else if (lastUpdatedData.exemption === true) {
        setVaccineStatus('exemption');
      }
    }
  }

  const Vaccinated = () => {
   // const [formValues, setFormValues] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [imageUrls, setImageUrls] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});

    const columns = [
      {
        key: 'test_date',
        dataIndex: 'test_date',
        title: 'Vaccine Date',
        sorter: (a, b) => moment(a.test_date).unix() - moment(b.test_date).unix(),
        render: (test_date) => (
          <span className='nowrap'>
            <strong> {test_date ? moment(test_date).format('MM/DD/YYYY') : ''}</strong>
          </span>
        )
      },
      {
        key: 'test_type',
        dataIndex: 'test_type',
        title: 'Vaccine Name',
        sorter: (a, b) => a.test_type.length - b.test_type.length,
        render: (test_type) => <strong>{test_type}</strong>
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Status',
        sorter: (a, b) => a.testing_status.length - b.testing_status.length,
        render: (testing_status) => <strong>{testing_status}</strong>
      },
      {
        key: 'dose',
        dataIndex: 'dose',
        title: 'Dose',
        // sorter: (a, b) => a.testing_status.length - b.testing_status.length,
        render: (dose) => <strong>{dose}</strong>
      },
      {
        key: 'approval_date',
        dataIndex: 'approval_date',
        title: 'Approval Date',
        render: (approval_date) => (
          <strong>{approval_date ? moment(approval_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'create_date',
        dataIndex: 'create_date',
        title: 'Created On',
        sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
        render: (create_date) => (
          <strong>{create_date ? moment(create_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'attachment_url',
        dataIndex: 'attachment_url',
        title: 'Document',
        render: (text, record) => (
          <span className='nowrap'>
            {!record.attachment_url ? (
              record.attachment_id.length > 0 && (
                <button onClick={(e) => download(e, record.attachment_id)}>Preview</button>
              )
            ) : (
              <button onClick={(e) => download(e, record.attachment_url)}>Preview</button>
            )}
          </span>
        )
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Action',
        render: (testing_status, record) => (
          <strong>
            {testing_status === 'pending' ? (
              <i
                className='icofont-edit'
                style={{ cursor: 'pointer' }}
                onClick={(e) => editData(record)}
              />
            ) : (
              ''
            )}
          </strong>
        )
      }
    ];

    function downloadImageUrl(attachment) {
      axios
        .post(setting.serverUrl + '/api/downloadVaccineCertificate_emp', {
          params: {
            email: localStorage.getItem('myData'),
            user: localStorage.getItem('myData'),
            // pass: localStorage.getItem('myPass'),
            attachment_detail: attachment
          }
        })
        .then((response) => {
          setImageUrls(response.data);
        });
    }

    const editData = (event) => {
      vaccinatedForm.setFieldsValue({
        vaccine_type: event.test_type,
        vaccine_date: moment(event.test_date),
        dose: event.dose
      });
      setIsEdit(true);
      setSelectedRow(event);
      downloadImageUrl(event.attachment_id);
    };

    const [vaccinatedForm] = Form.useForm();

    const saveVaccination = (values) => {
      if (
        values.vaccine_date &&
        values.vaccine_type &&
        values.dose &&
        ((values.vaccine_documents &&
          values.vaccine_documents.fileList &&
          values.vaccine_documents.fileList.length > 0) ||
          isEdit)
      ) {
        setLoaderVaccinated(true);
        const formData = new FormData();
        let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));
        if (
          values.vaccine_documents &&
          values.vaccine_documents.fileList &&
          values.vaccine_documents.fileList.length > 0
        ) {
          values.vaccine_documents.fileList.map((dat, index) => {
            formData.append('photo_pdf' + index, dat.originFileObj);
          });
        }

        formData.append('test_date', moment(values.vaccine_date).format('YYYY-MM-DD'));
        formData.append('test_type', values.vaccine_type);
        formData.append('dose', values.dose);
        formData.append('employee', employeeData.id);
        formData.append('company', employeeData.company[0]);
        formData.append('location', employeeData.emp_location[0]);
        formData.append('sex', employeeData.sex);
        formData.append('dob', moment(employeeData.dob).format('YYYY-MM-DD'));
        formData.append('email', employeeData.email);
        formData.append('first_name', employeeData.first_name);
        formData.append('vaccinated', 'true');
        formData.append('exemption', 'false');
        formData.append('unvaccinated', 'false');
        formData.append('plan_vac_value', '');
        formData.append('expactedDate', moment(values.vaccine_date).format('YYYY-MM-DD'));

        const headers = {
          'Content-Type': 'multipart/form-data'
        };

        let url = setting.serverUrl + '/api/saveCovidVaccination';
        if (isEdit) {
          url = setting.serverUrl + '/api/updateCovidVaccination';
          formData.append('id', selectedRow['id']);
        }

        axios({
          method: 'post',
          url: url,
          data: formData,
          headers: headers
        })

          .then((response) => {
            setLoaderVaccinated(false);
            if (response && response.status === 200) {

              if (response.data && response.data.error) {
                notification['error']({
                  message: 'Error',
                  description: response.data.error
                })
              }

              if (response.data && response.data.success) {
                notification['success']({
                  message: 'Success',
                  description: 'Information recorded!'
                })
                vaccinatedForm.resetFields();
                getCovidVaccinationData();
              }

            } else {
              notification['error']({
                message: 'Error',
                description: 'There is some technical issue. Please try again later.'
              })
            }

          })
          .catch((err) => console.log(err));
      }
    };

    return (
      <div>
        <Card>
          <h3>Please enter your vaccination information</h3>
          <Divider />

          <Form form={vaccinatedForm} onFinish={saveVaccination}>
            <div className='row'>
              <div className='col-md-3 col-sm-6'>
                <div className='col'>
                  <span>Vaccination date</span>

                  <FormItem
                    name='vaccine_date'
                    rules={[{ required: true, message: 'Please select date!' }]}
                  >
                    <DatePicker
                      allowClear={false}
                      style={{ width: '100%', borderRadius: 50, padding: 7 }}
                    />
                  </FormItem>

                  <span style={{ color: 'red' }}>{errors['test_date']}</span>
                </div>
              </div>
              <div className='col-md-3 col-sm-6'>
                <div className='col'>
                  <span>Vaccine name</span>

                  <FormItem
                    name='vaccine_type'
                    rules={[{ required: true, message: 'Please select vaccine!' }]}
                  >
                    {/* <Select defaultValue={test_type} onChange={addTestType}> */}
                    <Select allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                    }
                    >
                      <Option value=''> Select Vaccine</Option>
                      {vaccines.map((vaccine, i) => (
                        <Option key={i} value={vaccine}>
                          {vaccine}
                        </Option>
                      ))}
                    </Select>
                  </FormItem>

                  <span style={{ color: 'red' }}>{errors['test_type']}</span>
                </div>
              </div>
              <div className='col-md-3 col-sm-6'>
                <div className='col'>
                  <span>Select Dose</span>
                  <FormItem
                    name='dose'
                    rules={[{ required: true, message: 'Please select dose!' }]}
                  >
                    <Select allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                    }
                    >
                      <Option value=''>Select Dose</Option>
                      <Option value='First Dose'>First Dose</Option>
                      <Option value='Second Dose'>Second Dose</Option>
                      <Option value='Booster Dose'>Booster Dose</Option>
                      <Option value='Single Dose'>Single Dose</Option>
                    </Select>
                  </FormItem>
                  <span style={{ color: 'red' }}>{errors['dose']}</span>
                </div>
              </div>
              <div className='col'>
                <span>Upload Documents</span>

                <FormItem
                  name='vaccine_documents'
                  rules={[
                    {
                      required: isEdit ? false : true,
                      message: 'Please upload vaccine certificate!'
                    }
                  ]}
                >
                  <Dragger multiple={true}>
                    <p className='ant-upload-drag-icon'>
                      <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>Click or drag file to this area to upload</p>
                  </Dragger>
                </FormItem>
                {imageUrls &&
                  imageUrls.length > 0 &&
                  imageUrls.map((img) => {
                    return (
                      <p style={{ marginBottom: 10 }}>
                        <a href={img.url} target='_blank'>
                          {img.Key}
                        </a>
                      </p>
                    );
                  })}
              </div>
              <i style={{ color: "#1C3A6A", fontWeight: 700 }}>* If you are vaccinated and would like to claim a qualified exemption or vulnerable status, please
                also fill out the section below.
              </i>
              <Divider />
              <FormItem>
                {isEdit ? (
                  <Button
                    htmlType='submit'
                    style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                  >
                    Update Record
                  </Button>
                ) : (
                  <Button
                    htmlType='submit'
                    style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                  >
                    Save Record
                  </Button>
                )}
                {loaderVaccinated && (
                  <Space size='middle' style={{ marginLeft: 20 }}>
                    <Spin size='large' />
                  </Space>
                )}
              </FormItem>
            </div>
          </Form>
          <Divider />
          {CovidVaccinationData.length > 0 ? (
            <Table dataSource={CovidVaccinationData} columns={columns} />
          ) : null}
        </Card>
      </div>
    );
  };

  const Exemption = () => {
    const [isEditExemption, setIsEditExemption] = useState(false);
    const [imageUrlsExemption, setImageUrlsExemption] = useState([]);
    const [selectedRowExemption, setSelectedRowExemption] = useState({});
    const columns = [
      {
        key: 'test_date',
        dataIndex: 'test_date',
        title: 'Exemption Date',
        sorter: (a, b) => moment(a.test_date).unix() - moment(b.test_date).unix(),
        render: (test_date) => (
          <span className='nowrap'>
            <strong> {test_date ? moment(test_date).format('MM/DD/YYYY') : ''}</strong>
          </span>
        )
      },
      {
        key: 'exemption_type',
        dataIndex: 'exemption_type',
        title: 'Exemption Type',
        sorter: (a, b) => a.exemption_type.length - b.exemption_type.length,
        render: (exemption_type) => <strong>{exemption_type}</strong>
      },
      {
        key: 'exemption_comment',
        dataIndex: 'exemption_comment',
        title: 'Exemption Comment',
        sorter: (a, b) => a.exemption_comment.length - b.exemption_comment.length,
        render: (exemption_comment) => (
          <strong>{exemption_comment == 'undefined' ? '' : exemption_comment}</strong>
        )
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Status',
        sorter: (a, b) => a.testing_status.length - b.testing_status.length,
        render: (testing_status) => <strong>{testing_status}</strong>
      },
      {
        key: 'approval_date',
        dataIndex: 'approval_date',
        title: 'Approval Date',
        render: (approval_date) => (
          <strong>{approval_date ? moment(approval_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'create_date',
        dataIndex: 'create_date',
        title: 'Created On',
        sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
        render: (create_date) => (
          <strong>{create_date ? moment(create_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'attachment_url',
        dataIndex: 'attachment_url',
        title: 'Document',
        render: (text, record) => (
          <span className='nowrap'>
            {!record.attachment_url ? (
              record.attachment_id.length > 0 && (
                <button onClick={(e) => download(e, record.attachment_id)}>Preview</button>
              )
            ) : (
              <button onClick={(e) => download(e, record.attachment_url)}>Preview</button>
            )}
          </span>
        )
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Action',
        render: (testing_status, record) => (
          <strong>
            {testing_status === 'pending' ? (
              <i
                className='icofont-edit'
                style={{ cursor: 'pointer' }}
                onClick={(e) => editDataExemption(record)}
              />
            ) : (
              ''
            )}
          </strong>
        )
      }
    ];

    function downloadImageUrlExemption(attachment) {
      axios
        .post(setting.serverUrl + '/api/downloadVaccineCertificate_emp', {
          params: {
            email: localStorage.getItem('myData'),
            user: localStorage.getItem('myData'),
            // pass: localStorage.getItem('myPass'),
            attachment_detail: attachment
          }
        })
        .then((response) => {
          setImageUrlsExemption(response.data);
        });
    }

    const editDataExemption = (event) => {
      exemptionForm.setFieldsValue({
        exemption_type: event.exemption_type,
        exemption_date: moment(event.test_date),
        exemption_reason: event.exemption_comment
      });
      setIsEditExemption(true);
      setSelectedRowExemption(event);
      downloadImageUrlExemption(event.attachment_id);
    };


    const [exemptionForm] = Form.useForm();
    const saveExemption = (values) => {
      if (
        values.exemption_type &&
        values.exemption_date &&
        ((values.vaccine_documents &&
          values.vaccine_documents.fileList &&
          values.vaccine_documents.fileList.length > 0) ||
          isEditExemption)
      ) {
        setLoaderExemption(true);
        const formData = new FormData();
        let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));

        // formData.append('photo_pdf0', values.vaccine_documents.file.originFileObj);
        // formData.append(
        //   'photo_pdf_length',
        //   JSON.stringify(values.vaccine_documents.file.originFileObj)
        // );

        // if(values.vaccine_documents && values.vaccine_documents.fileList && values.vaccine_documents.fileList.length>0){
        //   values.vaccine_documents.fileList.map((dat, index) => {
        //     formData.append('photo_pdf' + index, dat.originFileObj);
        //   });
        // }

        if (
          values.vaccine_documents &&
          values.vaccine_documents.fileList &&
          values.vaccine_documents.fileList.length > 0
        ) {
          values.vaccine_documents.fileList.map((dat, index) => {
            formData.append('photo_pdf' + index, dat.originFileObj);
          });
        }

        formData.append('email', employeeData.email);
        formData.append('company', employeeData.company[0]);
        formData.append('employee', employeeData.id);
        formData.append('sex', employeeData.Gender);
        formData.append('dob', moment(employeeData.dob).format('YYYY-MM-DD'));
        formData.append('vaccinated', 'false');
        formData.append('exemption', 'true');
        formData.append('unvaccinated', 'false');
        formData.append('exemption_type', values.exemption_type);
        formData.append('exemption_comment', values.exemption_reason);
        formData.append('test_date', moment(values.exemption_date).format('YYYY-MM-DD'));
        formData.append('location', employeeData.emp_location[0]);
        formData.append('plan_vac_value', '');
        formData.append('expactedDate', '');

        const headers = {
          'Content-Type': 'multipart/form-data'
        };
        let url = setting.serverUrl + '/api/saveCovidVaccination';
        if (isEditExemption) {
          url = setting.serverUrl + '/api/updateCovidVaccination';
          formData.append('id', selectedRowExemption['id']);
        }

        axios({
          method: 'post',
          url: url,
          data: formData,
          headers: headers
        })
          .then((response) => {
            setLoaderExemption(false);
            if (response && response.status === 200) {

              if (response.data && response.data.error) {
                notification['error']({
                  message: 'Error',
                  description: response.data.error
                })
              }

              if (response.data && response.data.success) {
                notification['success']({
                  message: 'Success',
                  description: 'Information recorded!'
                })
                exemptionForm.resetFields();
                getCovidVaccinationData();
              }

            } else {
              notification['error']({
                message: 'Error',
                description: 'There is some technical issue. Please try again later.'
              })
            }

          })
          .catch((err) => console.log(err));
      }
    };
    return (
      <div>
        <h3>Vaccination Exemptions</h3>
        <Divider />
        <p>
          All employees of {companyName} must have at least two vaccine shots or a negative COVID
          test within 72 hours of returning to work. There are only three authorized exemptions for
          not being vaccinated. Select your exemption type below and the reason for your exemption.
        </p>
        <Divider />
        <Form form={exemptionForm} onFinish={saveExemption}>
          <div className='row'>
            <div className='col-md-3 col-sm-12'>
              <span>Exemption Date</span>
              <FormItem
                name='exemption_date'
                rules={[{ required: true, message: 'Please select exemption date' }]}
              >
                <DatePicker
                  // onChange={addTestDate}
                  style={{ width: '100%', borderRadius: 50, padding: 7 }}
                />
              </FormItem>
            </div>
            <div className='col-md-3 col-sm-12'>
              <span>Exemption Type</span>
              <FormItem
                name='exemption_type'
                rules={[{ required: true, message: 'Please select exemption type' }]}
              >
                <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                }
                >
                  <Option value='medical'>Medical</Option>
                  <Option value='religious'>Religious</Option>
                  {/* <Option value='vulnerable'>Vulnerable</Option> */}
                </Select>
              </FormItem>
            </div>
            <div className='col-md-3 col-sm-12'>
              <span>Reason for Exemption</span>
              <FormItem name='exemption_reason'>
                <Input />
              </FormItem>
            </div>
            <div className='col'>
              <span>Upload Documents</span>

              <FormItem
                name='vaccine_documents'
                rules={[
                  {
                    required: isEditExemption ? false : true,
                    message: 'Please upload vaccine certificate!'
                  }
                ]}
              >
                <Dragger multiple={true}>
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>Click or drag file to this area to upload</p>
                </Dragger>
              </FormItem>
              {imageUrlsExemption &&
                imageUrlsExemption.length > 0 &&
                imageUrlsExemption.map((img) => {
                  return (
                    <p style={{ marginBottom: 10 }}>
                      <a href={img.url} target='_blank'>
                        {img.Key}
                      </a>
                    </p>
                  );
                })}
              {/* <span style={{ color: 'red' }}>{errors['photo_pdf']}</span> */}
            </div>
          </div>
          <Divider />
          <>
            <h6 style={{ color: "#1C3A6A" }}><u>
              Exemption Status Descriptions
            </u></h6>
            <h6 style={{ color: "grey" }}>Religious Exemption -employees who are declining vaccination because of a sincerely
              held religious belief.</h6>

            <h6 style={{ color: "grey" }}> Medical Exemption -employees who are permanently declining vaccination as they may be at
              risk for an adverse reaction because of (1) an allergy to one of the components or (2) a medical
              condition. These employees must have an exemption letter from their own Doctor/Physician as a
              supporting document.</h6>
          </>

          <i style={{ color: "#1C3A6A", fontWeight: 700 }}>*If you are seeking Vulnerable Status please fill out the section below.</i>
          <br /><br />
          <div className='col-md-3 col-sm-12'>
            <FormItem>
              {isEditExemption ? (
                <Button
                  htmlType='submit'
                  style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                >
                  Update Record
                </Button>
              ) : (
                <Button
                  style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                  htmlType='submit'
                >
                  Add to Record
                </Button>
              )}


              {loaderExemption && (
                <Space size='middle' style={{ marginLeft: 20 }}>
                  <Spin size='large' />
                </Space>
              )}
            </FormItem>
          </div>
        </Form>
        <Divider />
        {CovidExemptionData.length > 0 ? (
          <Table dataSource={CovidExemptionData} columns={columns} />
        ) : null}
      </div>
    );
  };
  const Vulnerable = () => {
    const [isEditExemption, setIsEditExemption] = useState(false);
    const [imageUrlsExemption, setImageUrlsExemption] = useState([]);
    const [selectedRowExemption, setSelectedRowExemption] = useState({});
    const columns = [
      {
        key: 'test_date',
        dataIndex: 'test_date',
        title: 'Exemption Date',
        sorter: (a, b) => moment(a.test_date).unix() - moment(b.test_date).unix(),
        render: (test_date) => (
          <span className='nowrap'>
            <strong> {test_date ? moment(test_date).format('MM/DD/YYYY') : ''}</strong>
          </span>
        )
      },
      {
        key: 'exemption_type',
        dataIndex: 'exemption_type',
        title: 'Exemption Type',
        sorter: (a, b) => a.exemption_type.length - b.exemption_type.length,
        render: (exemption_type) => <strong>{exemption_type}</strong>
      },
      {
        key: 'exemption_comment',
        dataIndex: 'exemption_comment',
        title: 'Exemption Comment',
        sorter: (a, b) => a.exemption_comment.length - b.exemption_comment.length,
        render: (exemption_comment) => (
          <strong>{exemption_comment == 'undefined' ? '' : exemption_comment}</strong>
        )
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Status',
        sorter: (a, b) => a.testing_status.length - b.testing_status.length,
        render: (testing_status) => <strong>{testing_status}</strong>
      },
      {
        key: 'approval_date',
        dataIndex: 'approval_date',
        title: 'Approval Date',
        render: (approval_date) => (
          <strong>{approval_date ? moment(approval_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'create_date',
        dataIndex: 'create_date',
        title: 'Created On',
        sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
        render: (create_date) => (
          <strong>{create_date ? moment(create_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'attachment_url',
        dataIndex: 'attachment_url',
        title: 'Document',
        render: (text, record) => (
          <span className='nowrap'>
            {!record.attachment_url ? (
              record.attachment_id.length > 0 && (
                <button onClick={(e) => download(e, record.attachment_id)}>Preview</button>
              )
            ) : (
              <button onClick={(e) => download(e, record.attachment_url)}>Preview</button>
            )}
          </span>
        )
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Action',
        render: (testing_status, record) => (
          <strong>
            {testing_status === 'pending' ? (
              <i
                className='icofont-edit'
                style={{ cursor: 'pointer' }}
                onClick={(e) => editDataExemption(record)}
              />
            ) : (
              ''
            )}
          </strong>
        )
      }
    ];

    function downloadImageUrlExemption(attachment) {
      axios
        .post(setting.serverUrl + '/api/downloadVaccineCertificate_emp', {
          params: {
            email: localStorage.getItem('myData'),
            user: localStorage.getItem('myData'),
            // pass: localStorage.getItem('myPass'),
            attachment_detail: attachment
          }
        })
        .then((response) => {
          setImageUrlsExemption(response.data);
        });
    }

    const editDataExemption = (event) => {
      exemptionForm.setFieldsValue({
        exemption_type: event.exemption_type,
        exemption_date: moment(event.test_date),
        exemption_reason: event.exemption_comment
      });
      setIsEditExemption(true);
      setSelectedRowExemption(event);
      downloadImageUrlExemption(event.attachment_id);
    };


    const [exemptionForm] = Form.useForm();
    const saveExemption = (values) => {
      if (
        // values.exemption_type &&
        values.exemption_date &&
        ((values.vaccine_documents &&
          values.vaccine_documents.fileList &&
          values.vaccine_documents.fileList.length > 0) ||
          isEditExemption)
      ) {
        setLoaderExemption(true);
        const formData = new FormData();
        let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));

        if (
          values.vaccine_documents &&
          values.vaccine_documents.fileList &&
          values.vaccine_documents.fileList.length > 0
        ) {
          values.vaccine_documents.fileList.map((dat, index) => {
            formData.append('photo_pdf' + index, dat.originFileObj);
          });
        }

        formData.append('email', employeeData.email);
        formData.append('company', employeeData.company[0]);
        formData.append('employee', employeeData.id);
        formData.append('sex', employeeData.Gender);
        formData.append('dob', moment(employeeData.dob).format('YYYY-MM-DD'));
        formData.append('vaccinated', 'false');
        formData.append('exemption', 'true');
        formData.append('unvaccinated', 'false');
        formData.append('exemption_type', 'vulnerable');
        formData.append('exemption_comment', values.exemption_reason);
        formData.append('test_date', moment(values.exemption_date).format('YYYY-MM-DD'));
        formData.append('location', employeeData.emp_location[0]);
        formData.append('plan_vac_value', '');
        formData.append('expactedDate', '');

        const headers = {
          'Content-Type': 'multipart/form-data'
        };
        let url = setting.serverUrl + '/api/saveCovidVaccination';
        if (isEditExemption) {
          url = setting.serverUrl + '/api/updateCovidVaccination';
          formData.append('id', selectedRowExemption['id']);
        }

        axios({
          method: 'post',
          url: url,
          data: formData,
          headers: headers
        })
          .then((response) => {
            setLoaderExemption(false);
            if (response && response.status === 200) {

              if (response.data && response.data.error) {
                notification['error']({
                  message: 'Error',
                  description: response.data.error
                })
              }

              if (response.data && response.data.success) {
                notification['success']({
                  message: 'Success',
                  description: 'Information recorded!'
                })
                exemptionForm.resetFields();
                getCovidVaccinationData();
              }

            } else {
              notification['error']({
                message: 'Error',
                description: 'There is some technical issue. Please try again later.'
              })
            }

          })
          .catch((err) => console.log(err));
      }
    };
    return (
      <div>
        <h3>Vulnerability Status</h3>
        <Divider />
        <p>
          Employees who would like to apply for vulnerable status to continue working from home within a
          certain time frame as they may be at certain high risk to undergo vaccination at this time as
          per CDC guidelines. Such as, exposure to COVID-19, pregnancy, etc.
        </p>
        <Divider />
        <Form form={exemptionForm} onFinish={saveExemption}>
          <div className='row'>
            <div className='col-md-3 col-sm-12'>
              <span>Starting Date Requested</span>
              <FormItem
                name='exemption_date'
                rules={[{ required: true, message: 'Please select exemption date' }]}
              >
                <DatePicker
                  // onChange={addTestDate}
                  style={{ width: '100%', borderRadius: 50, padding: 7 }}
                />
              </FormItem>
            </div>

            <div className='col-md-3 col-sm-12'>
              <span>Reason for vulnerable</span>
              <FormItem name='exemption_reason'>
                <Input />
              </FormItem>
            </div>
            <div className='col'>
              <span>Upload Documents</span>

              <FormItem
                name='vaccine_documents'
                rules={[
                  {
                    required: isEditExemption ? false : true,
                    message: 'Please upload vaccine certificate!'
                  }
                ]}
              >
                <Dragger multiple={true}>
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>Click or drag file to this area to upload</p>
                </Dragger>
              </FormItem>
              {imageUrlsExemption &&
                imageUrlsExemption.length > 0 &&
                imageUrlsExemption.map((img) => {
                  return (
                    <p style={{ marginBottom: 10 }}>
                      <a href={img.url} target='_blank'>
                        {img.Key}
                      </a>
                    </p>
                  );
                })}
              {/* <span style={{ color: 'red' }}>{errors['photo_pdf']}</span> */}
            </div>
          </div>
          <i style={{ color: "#1C3A6A", fontWeight: 700 }}>*Please make sure you have added your doctor's name and uploaded your corresponding documents.</i>
          <Divider />

          <div className='col-md-3 col-sm-12'>
            <FormItem>
              {isEditExemption ? (
                <Button
                  htmlType='submit'
                  style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                >
                  Update Record
                </Button>
              ) : (

                <Button
                  style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                  htmlType='submit'
                >
                  Add to Record
                </Button>
              )}
              {loaderExemption && (
                <Space size='middle' style={{ marginLeft: 20 }}>
                  <Spin size='large' />
                </Space>
              )}
            </FormItem>
          </div>
        </Form>
        <Divider />
        {CovidVulnerableData.length > 0 ? (
          <Table dataSource={CovidVulnerableData} columns={columns} />
        ) : null}
      </div>
    );
  };

  const Unvaccinated = () => {
    const [unvaccinatedForm] = Form.useForm();
    const [isVaccinated, setIsVaccinated] = useState(false);

    const [isEditUnvaccinated, setIsEditUnvaccinated] = useState(false);
    // const [imageUrlsExemption, setImageUrlsExemption] = useState([]);
    const [selectedRowUnvaccinated, setSelectedRowUnvaccinated] = useState({});

    const columns = [
      // {
      //   key: 'test_date',
      //   dataIndex: 'test_date',
      //   title: 'Exemption Date',
      //   sorter: (a, b) => moment(a.test_date).unix() - moment(b.test_date).unix(),
      //   render: (test_date) => (
      //     <span className='nowrap'>
      //       <strong> {test_date ? moment(test_date).format('MM/DD/YYYY') : ''}</strong>
      //     </span>
      //   )
      // },
      {
        key: 'interestedInVaccination',
        dataIndex: 'interestedInVaccination',
        title: 'Vaccination Plan',
        sorter: (a, b) => a.interestedInVaccination.length - b.interestedInVaccination.length,
        render: (interestedInVaccination) => <strong>{interestedInVaccination}</strong>
      },
      {
        key: 'expactedDate',
        dataIndex: 'expactedDate',
        title: 'Expected Date',
        sorter: (a, b) => a.expactedDate.length - b.expactedDate.length,
        render: (expactedDate) =>
          expactedDate !== '1111-01-01' ? <strong>{expactedDate}</strong> : <strong>N/A</strong>
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Status',
        sorter: (a, b) => a.testing_status.length - b.testing_status.length,
        render: (testing_status) => <strong>{testing_status}</strong>
      },
      {
        key: 'approval_date',
        dataIndex: 'approval_date',
        title: 'Approval Date',
        render: (approval_date) => (
          <strong>{approval_date ? moment(approval_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'create_date',
        dataIndex: 'create_date',
        title: 'Created On',
        sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
        render: (create_date) => (
          <strong>{create_date ? moment(create_date).format('MM-DD-YYYY hh:mm a') : ''}</strong>
        )
      },
      {
        key: 'attachment_url',
        dataIndex: 'attachment_url',
        title: 'Document',
        render: (text, record) => (
          <span className='nowrap'>
            {!record.attachment_url ? (
              record.attachment_id.length > 0 && (
                <button onClick={(e) => download(e, record.attachment_id)}>Preview</button>
              )
            ) : (
              <button onClick={(e) => download(e, record.attachment_url)}>Preview</button>
            )}
          </span>
        )
      },
      {
        key: 'testing_status',
        dataIndex: 'testing_status',
        title: 'Action',
        render: (testing_status, record) => (
          <strong>
            {testing_status === 'pending' ? (
              <i
                className='icofont-edit'
                style={{ cursor: 'pointer' }}
                onClick={(e) => editDataUnvaccinated(record)}
              />
            ) : (
              ''
            )}
          </strong>
        )
      },

    ];

    const editDataUnvaccinated = (event) => {
      if (event.interestedInVaccination == 'Yes') {
        setIsVaccinated(true);
      } else {
        setIsVaccinated(false);
      }

      unvaccinatedForm.setFieldsValue({
        plan_vac_value: event.interestedInVaccination,
        date_to_vaccinate: event.expactedDate !== '1111-01-01' ? moment(event.expactedDate) : null
        // exemption_reason : event.exemption_comment
      });
      setIsEditUnvaccinated(true);
      setSelectedRowUnvaccinated(event);
      // downloadImageUrlExemption(event.attachment_id);
    };

    const saveUnvaccinated = (values) => {
      // if (values.plan_vac_value && (values.unvaccinated_documents &&
      //   values.unvaccinated_documents.fileList &&
      //   values.unvaccinated_documents.fileList.length > 0)|| isEditUnvaccinated) {

      if (values.plan_vac_value || isEditUnvaccinated) {

        setLoaderUnvaccinated(true);
        const formData = new FormData();
        let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));

        if (
          values.unvaccinated_documents &&
          values.unvaccinated_documents.fileList &&
          values.unvaccinated_documents.fileList.length > 0
        ) {
          values.unvaccinated_documents.fileList.map((dat, index) => {
            formData.append('photo_pdf' + index, dat.originFileObj);
          });
        }

        formData.append('email', employeeData.email);
        formData.append('company', employeeData.company[0]);
        formData.append('employee', employeeData.id);
        formData.append('sex', employeeData.Gender);
        formData.append('dob', moment(employeeData.dob).format('YYYY-MM-DD'));
        formData.append('vaccinated', 'false');
        formData.append('exemption', 'false');
        formData.append('unvaccinated', 'true');
        formData.append('exemption_type', values.exemption_type);
        formData.append('exemption_comment', '');
        formData.append('test_date', moment(values.exemption_date).format('YYYY-MM-DD'));
        formData.append('location', employeeData.emp_location[0]);
        formData.append('plan_vac_value', values.plan_vac_value);
        formData.append(
          'expactedDate',
          values.date_to_vaccinate && values.plan_vac_value == 'Yes'
            ? moment(values.date_to_vaccinate).format('YYYY-MM-DD')
            : '1111-01-01'
        );

        const headers = {
          'Content-Type': 'multipart/form-data'
        };

        let url = setting.serverUrl + '/api/saveCovidVaccination';
        if (isEditUnvaccinated) {
          url = setting.serverUrl + '/api/updateCovidVaccination';
          formData.append('id', selectedRowUnvaccinated['id']);
        }

        axios({
          method: 'post',
          url: url,
          data: formData,
          headers: headers
        })
          .then((response) => {
            setLoaderUnvaccinated(false);
            if (response && response.status === 200) {

              if (response.data && response.data.error) {
                notification['error']({
                  message: 'Error',
                  description: response.data.error
                })
              }

              if (response.data && response.data.success) {
                notification['success']({
                  message: 'Success',
                  description: 'Information recorded!'
                })
                unvaccinatedForm.resetFields();
                getCovidVaccinationData();
              }

            } else {
              notification['error']({
                message: 'Error',
                description: 'There is some technical issue. Please try again later.'
              })
            }

          })
          .catch((err) => {
            notification.error({
              message: 'Could not connect to server. Please try again in a while.'
            })
          });
      }
    };

    function onPlanVacc(event) {
      if (event === 'Yes') {
        setIsVaccinated(true);
        // setplan_vac_value('Yes')
      } else {
        setIsVaccinated(false);
        // setplan_vac_value('No')
      }
    }

    return (
      <div>
        <h3>Unvaccinated Employees</h3>
        <Divider />
        <Form form={unvaccinatedForm} onFinish={saveUnvaccinated}>
          <div className='row'>
            {/* <div className='col'> */}
            <div className='col-md-4 col-sm-12'>
              <span>Do you plan to get vaccinated?</span>

              <FormItem
                name='plan_vac_value'
                rules={[{ required: true, message: 'This field is required!' }]}
              >
                <Select onChange={onPlanVacc}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                }
                >
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                </Select>
              </FormItem>
            </div>

            {isVaccinated ? (
              <div className='col-md-4 col-sm-12'>
                <span>What date are you getting vaccinated?</span>
                <FormItem name='date_to_vaccinate'>
                  <DatePicker style={{ width: '100%', borderRadius: 50, padding: 7 }} />
                </FormItem>
              </div>
            ) : null}

            <div className='col-md-4 col-sm-12'>
              <FormItem
                name='unvaccinated_documents'
                rules={[
                  {
                    required: false,
                    message: 'Please upload vaccine certificate!'
                  }
                ]}
              >
                <Dragger multiple={true}>
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>Click or drag file to this area to upload</p>
                </Dragger>
              </FormItem>
            </div>

            <Divider />

            <div className='col-md-4 col-sm-12'>
              <FormItem>
                {isEditUnvaccinated ? (
                  <Button
                    htmlType='submit'
                    style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                  >
                    Update Record
                  </Button>
                ) : (
                  <Button
                    htmlType='submit'
                    style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                  >
                    Record Answer
                  </Button>
                )}

                {loaderUnvaccinated && (
                  <Space size='middle' style={{ marginLeft: 20 }}>
                    <Spin size='large' />
                  </Space>
                )}
              </FormItem>
            </div>
          </div>
        </Form>
        <Divider />
        {CovidUnvaccinationData.length > 0 ? (
          <Table dataSource={CovidUnvaccinationData} columns={columns} />
        ) : null}
      </div>
    );
  };

  return (
    <div style={{ padding: 30 }}>
      <Row>
        <Col span={12}>
          <h5 style={{ padding: 10, textAlign: 'left', color: '#425a81' }}>
            {companyName} - Covid Vaccinations
          </h5>
        </Col>
      </Row>
      <Collapse accordion>
        <Panel
          style={{ background: '#2F7197', borderRadius: '10px 10px 0px 0px', color: 'white' }}
          className='ant-collapse-header'
          header={
            <span style={{ color: 'white', fontSize: '140%' }}>
              I <u>am</u> Vaccinated
            </span>
          }
          key='1'
          extra={
            vaccineStatus === 'vaccinated' ? (
              <span style={{ color: 'white' }}>
                Last updated : {moment(lastUpdate).format('MM-DD-YYYY hh:mm a')} &nbsp;{' '}
                <CheckCircleOutlined />
              </span> 
            ) : null
          }
        >
          <Vaccinated />
        </Panel>
        <Panel
          style={{ background: '#8aacc2' }}
          header={
            <span style={{ color: 'white', fontSize: '140%' }}>
              I am <u>not</u> Vaccinated
            </span>
          }
          key='3'
          extra={
            vaccineStatus === 'unvaccinated' ? (
              <span style={{ color: 'white' }}>
                Last updated : {moment(lastUpdate).format('MM-DD-YYYY hh:mm a')} &nbsp;{' '}
                <CheckCircleOutlined />
              </span>
            ) : null
          }
        >
          <Unvaccinated />
        </Panel>
        <Panel
          style={{ background: '#1C3A6A' }}
          header={
            <span style={{ color: 'white', fontSize: '140%' }}>
              {/* I am <u>exempt</u> from being Vaccinated OR seeking <u>vulnerable</u> status */}
              I am requesting an <u>accomodation</u> from being Vaccinated.
            </span>
          }
          key='2'
          extra={
            vaccineStatus === 'exemption' ? (
              <span style={{ color: 'white' }}>
                Last updated : {moment(lastUpdate).format('MM-DD-YYYY hh:mm a')} &nbsp;{' '}
                <CheckCircleOutlined />
              </span>
            ) : null
          }
        >
          <Exemption />
        </Panel>

      </Collapse>
      <Row>
        <Col span={12}>
          <h5 style={{ padding: 10, textAlign: 'left', color: '#425a81' }}>
            {companyName} - Vulnerability Status
          </h5>
        </Col>
      </Row>
      <Collapse accordion>
        <Panel
          style={{ background: '#EF6828', borderRadius: '10px 10px 10px 10px' }}
          header={
            <span style={{ color: 'white', fontSize: '140%' }}>
              I am  seeking <u>vulnerable</u> status.
            </span>
          }
          key='3'
          extra={
            vaccineStatus === 'unvaccinated' ? (
              <span style={{ color: 'white' }}>
                Last updated : {moment(lastUpdate).format('MM-DD-YYYY hh:mm a')} &nbsp;{' '}
                <CheckCircleOutlined />
              </span>
            ) : null
          }
        >
          <Vulnerable />
        </Panel>
      </Collapse>
      <Modal
        width={1000}
        title='Documents Preview'
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {imageUrls &&
          imageUrls.length > 0 &&
          imageUrls.map((img) => {
            return (
              <p>
                {img.fileType && img.fileType == 'application/pdf' ? (
                  <embed src={img.url} width='800px' height='2100px' />
                ) : (
                  <img src={img.url} />
                )}
              </p>
            );
          })}
      </Modal>
    </div>
  );
};

export default CovidVaccination;
